<ng-content select=".btn--editor-controls"></ng-content>

<div class="column-video">
  <iframe width="560" height="349" [src]="videoUrl | safe: 'resourceUrl'" frameborder="0" ></iframe>
</div>
